export default "__VITE_ASSET__xTGjWzVr__"